import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'main-configuracao-view',
    templateUrl: './main-configuracao-view.component.html',
    styleUrls: ['./main-configuracao-view.component.scss'],
    standalone: false
})
export class MainConfiguracaoViewComponent implements OnInit {

  @Input() id:string;
  constructor() { }

  ngOnInit(): void {
  }

}
